import ColorfulTypography from './colorful-typography';
export default ColorfulTypography;
